import users from "./users";

export const USERS_NAMESPACE = "users";

export default users;
